import React, { Component } from 'react';

export default class PackageCreator extends Component {

  constructor(props){
    super(props);

    this.state = {
      type: '-1',
    };
  }

  onTypeChange = (event) => {
    this.setState({type: event.target.value});
  };

  onAddClick = () => {
    if (this.state.type !== '-1'){
      this.props.onPackageAdd(this.state.type);
    }
  };

  render() {
    return (
      <div className="package-creator">
        <select className="w-100 pl-1" id="select" name="select" onChange={this.onTypeChange} value={this.state.type}>
          <option value="-1" disabled>Choose a package type</option>
          {this.props.packageTypes.map((p,idx) => {
                return(<option value={p.id} key={p.id}>{p.name}</option>)
              })
          }
        </select>
        <div className="btn btn-success mr-0 d-flex align-items-center" onClick={this.onAddClick}><i className="fa fa-plus mr-05"></i>Add Package</div>
      </div>
    )
  }
}
